/* eslint-disable @typescript-eslint/no-unused-vars */
import { AppTheme, SCALE_COLORS } from './theme'

type ColorParam = { theme: AppTheme }

export type ColorSelector = (params: ColorParam) => string

export const color = {
    brand: {
        primary: (params: ColorParam): string => params.theme.colors.brand.primary,
        muted: (params: ColorParam): string => params.theme.colors.brand.muted,
        alt: (params: ColorParam): string => params.theme.colors.brand.alt,
        dark: (params: ColorParam): string => params.theme.colors.brand.dark,
        scale: (index: 0 | 1 | 2 | 3) => (): string => {
            return SCALE_COLORS[index]
        },
    },
    background: {
        app: (params: ColorParam): string => params.theme.colors.background.app,
        secondaryContent: (): string => '#fdfdfe',
        control: (params: ColorParam): string => params.theme.colors.background.control,
        content: (params: ColorParam): string => params.theme.colors.background.content,
        muted: (params: ColorParam): string => params.theme.colors.background.muted,
        inverted: (params: ColorParam): string => params.theme.colors.background.inverted,
        nav: (params: ColorParam): string => '#192531',
        navAlt: (params: ColorParam): string => '#203040',
        tableFilters: (params: ColorParam): string => params.theme.colors.background.app,
        tableFooter: (params: ColorParam): string => params.theme.colors.background.app,
        tableHeader: (params: ColorParam): string => params.theme.colors.background.app,
        contentActive: (params: ColorParam): string => params.theme.colors.background.contentActive,
    },
    border: {
        primary: (params: ColorParam): string => params.theme.colors.border.primary,
        secondary: (params: ColorParam): string => params.theme.colors.border.secondary,
        muted: (params: ColorParam): string => params.theme.colors.border.muted,
    },
    text: {
        primary: (params: ColorParam): string => params.theme.colors.text.primary,
        secondary: (params: ColorParam): string => params.theme.colors.text.secondary,
        muted: (params: ColorParam): string => params.theme.colors.text.muted,
        inverted: (params: ColorParam): string => params.theme.colors.text.inverted,
        disabled: (params: ColorParam): string => params.theme.colors.text.inverted,
    },
    icon: {
        primary: (params: ColorParam): string => params.theme.colors.icon.primary,
        inverted: (params: ColorParam): string => params.theme.colors.icon.inverted,
        muted: (params: ColorParam): string => params.theme.colors.icon.muted,
        activity: (params: ColorParam): string => params.theme.colors.icon.activity,
        activityMuted: (params: ColorParam): string => params.theme.colors.icon.activityMuted,
        danger: (params: ColorParam): string => params.theme.colors.icon.danger,
        dangerMuted: (params: ColorParam): string => params.theme.colors.icon.dangerMuted,
        secondary: (params: ColorParam): string => params.theme.colors.icon.secondary,
    },
    link: {
        primary: (params: ColorParam): string => params.theme.colors.link.primary,
    },
    input: {
        label: (params: ColorParam): string => params.theme.colors.input.label,
    },
    status: {
        success: (params: ColorParam): string => params.theme.colors.status.success,
        active: (): string => '#00C853',
        update: (params: ColorParam): string => params.theme.colors.status.update,
        danger: (params: ColorParam): string => params.theme.colors.status.danger,
        dangerMuted: (params: ColorParam): string => params.theme.colors.status.dangerMuted,
        warning: (params: ColorParam): string => params.theme.colors.status.warning,
        passive: (params: ColorParam): string => params.theme.colors.status.passive,
    },
    skeleton: {
        light: (params: ColorParam): string => '#ececec',
        dark: (params: ColorParam): string => '#d9d9d9',
    },
    control: {
        inactive: (params: ColorParam): string => params.theme.colors.control.inactive,
        active: (params: ColorParam): string => params.theme.colors.control.active,
        muted: (params: ColorParam): string => params.theme.colors.control.muted,
    },
}
